import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IPublicLink } from '@/contracts/system-modules/share/IPublicLink'
import { CreateChildLinkParams } from '@/system-modules/share/v1/api/v1/share/CreateChildLink/Dto/CreateChildLinkParams'

/** Открытый маршрут: передарить ссылку может любой, кто её открыл */
export class CreateChildLinkRoute extends ShareRoute<CreateChildLinkParams, IPublicLink> {
  constructor(private readonly parentUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/share/public/links/' + this.parentUuid + '/links'
  }

  /** Без сервера родительской ссылки нет */
  offline(): Promise<ApiResponse<IPublicLink>> {
    return Promise.resolve(new ApiResponse({ success: false, error: 'link_not_found' }))
  }
}
